import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { ScrollReveal } from '../components/ScrollReveal';
import { NextPageLink } from '../components/NextPageLink';
import { useSEO } from '../utils/seo';
export const Tarifs = () => {
  useSEO({
    title: 'Tarifs Détatouage Laser | Prix par Séance | Dispel Your Tattoo Martigny',
    description: 'Tarifs transparents pour le détatouage laser à Martigny. Prix par séance selon la taille du tatouage, à partir de 70 CHF. Consultation gratuite et sans engagement.',
    canonical: '/tarifs'
  });
  const pricingTiers = [{
    name: 'Consultation / Rendez-vous discussion',
    price: 'Gratuit !',
    highlight: true
  }, {
    name: 'Petit tatouage',
    price: 'de 70.- à 150.-',
    highlight: false
  }, {
    name: 'Tatouage moyen',
    price: 'de 150.- à 300.-',
    highlight: false
  }, {
    name: 'Grand tatouage',
    price: 'de 300.- à 450.-',
    highlight: false
  }, {
    name: 'Tatouage XXL',
    price: 'sur demande',
    note: '(Un grand tatouage ou tatouage xxl sera séparé en plusieurs séances pour le confort du client et pour ne pas surcharger le système lymphatique)',
    highlight: false
  }, {
    name: 'Détatouage des sourcils',
    price: '120.-',
    highlight: false
  }];
  const reviews = [{
    quote: 'Des tarifs clairs dès le départ, aucune mauvaise surprise. Le rapport qualité-prix est excellent vu le professionnalisme.',
    author: 'Sophie, Sion'
  }, {
    quote: "La consultation gratuite m'a permis de comprendre exactement le budget nécessaire pour mon projet. Très appréciable.",
    author: 'Julien, Martigny'
  }];
  return <main className="pt-32 pb-0 bg-brand-dark" data-id="element-1061">
      {/* Header Section */}
      <section className="py-12 md:py-16 lg:py-24 bg-brand-darker text-center px-6 md:px-12" data-id="element-1062">
        <div className="max-w-[1000px] mx-auto" data-id="element-1063">
          <ScrollReveal data-id="element-1064">
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-medium text-brand-light mb-8 md:mb-12 tracking-tight text-balance" data-id="element-1065">
              TARIFS Détatouage
            </h1>
          </ScrollReveal>
          <ScrollReveal delay={0.1} data-id="element-1066">
            <div className="text-base md:text-lg lg:text-xl text-brand-gray font-light leading-relaxed max-w-3xl mx-auto space-y-4 md:space-y-6" data-id="element-1067">
              <p data-id="element-1068">
                La séance de détatouage laser est facturée en fonction de la
                superficie du tatouage. Les tarifs sont établis par zones, à
                partir de 70 CHF pour les plus petits tatouages.
              </p>
              <p data-id="element-1069">
                Pour obtenir un devis gratuit et sans engagement, merci de me
                contacter via le formulaire en indiquant vos coordonnées.
              </p>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="py-16 md:py-24 lg:py-32 px-6 md:px-12 max-w-[1000px] mx-auto" data-id="element-1070">
        <ScrollReveal data-id="element-1071">
          <div className="text-center mb-10 md:mb-16" data-id="element-1072">
            <h2 className="text-2xl md:text-3xl lg:text-5xl font-medium mb-4 md:mb-6 tracking-tight" data-id="element-1073">
              Prix approximatifs à la séance
            </h2>
            <p className="text-lg md:text-xl text-brand-gray font-light" data-id="element-1074">
              Chaque devis est personnalisé selon votre tatouage
            </p>
          </div>
        </ScrollReveal>

        <div className="space-y-3 md:space-y-4" data-id="element-1075">
          {pricingTiers.map((tier, index) => <ScrollReveal key={index} delay={index * 0.1} data-id="element-1076">
              <div className={`flex flex-col sm:flex-row sm:items-center justify-between p-5 md:p-6 lg:p-8 rounded-2xl border ${tier.highlight ? 'bg-brand-light text-brand-dark border-brand-light' : 'bg-brand-darker border-brand-border/30 text-brand-light'}`} data-id="element-1077">
                <div className="mb-3 sm:mb-0" data-id="element-1078">
                  <h3 className={`text-lg md:text-xl lg:text-2xl font-bold ${tier.highlight ? 'text-brand-dark' : 'text-brand-light'}`} data-id="element-1079">
                    {tier.name}
                  </h3>
                  {tier.note && <p className={`text-xs md:text-sm mt-1.5 md:mt-2 max-w-lg ${tier.highlight ? 'text-brand-dark/70' : 'text-brand-gray'}`} data-id="element-1080">
                      {tier.note}
                    </p>}
                </div>
                <div className={`text-lg md:text-xl lg:text-2xl font-bold whitespace-nowrap ${tier.highlight ? 'text-brand-dark' : 'text-brand-light'}`} data-id="element-1081">
                  {tier.price}
                </div>
              </div>
            </ScrollReveal>)}
        </div>

        <ScrollReveal delay={0.4} data-id="element-1082">
          <div className="mt-12 md:mt-16 bg-brand-darker border border-brand-border/30 rounded-2xl p-6 md:p-8 lg:p-12" data-id="element-1083">
            <h3 className="text-xl md:text-2xl font-bold text-brand-light mb-4 md:mb-6" data-id="element-1084">
              Acompte de réservation – Nouveaux clients
            </h3>
            <div className="space-y-3 md:space-y-4 text-sm md:text-base text-brand-gray font-light leading-relaxed" data-id="element-1085">
              <p data-id="element-1086">
                Pour tout premier rendez-vous, un acompte de 50 CHF est demandé
                afin de valider la réservation. Ce montant sera entièrement
                déduit du prix de la première séance.
              </p>
              <p data-id="element-1087">Le paiement de l'acompte se fait simplement via TWINT.</p>
              <p className="text-xs md:text-sm text-brand-gray/60 mt-4 md:mt-6 italic" data-id="element-1088">
                En cas d'annulation moins de 24 heures à l'avance, l'acompte
                sera conservé ou un montant forfaitaire de 50 CHF sera facturé.
              </p>
            </div>
          </div>
        </ScrollReveal>
      </section>

      {/* CTA Section */}
      <section className="py-16 md:py-24 bg-brand-light text-brand-dark text-center px-6 md:px-12" data-id="element-1089">
        <div className="max-w-3xl mx-auto" data-id="element-1090">
          <ScrollReveal data-id="element-1091">
            <h2 className="text-2xl md:text-3xl lg:text-5xl font-bold mb-4 md:mb-6 tracking-tight" data-id="element-1092">
              Obtenez votre devis personnalisé
            </h2>
          </ScrollReveal>
          <ScrollReveal delay={0.1} data-id="element-1093">
            <p className="text-base md:text-lg lg:text-xl font-medium text-brand-dark/70 mb-8 md:mb-10 leading-relaxed" data-id="element-1094">
              La consultation est gratuite. Discutons de votre projet pour
              établir un plan de traitement et un tarif précis.
            </p>
          </ScrollReveal>
          <ScrollReveal delay={0.2} data-id="element-1095">
            <Link to="/contact#consultation-form" className="inline-flex items-center space-x-2 px-8 md:px-10 py-4 md:py-5 bg-brand-dark text-brand-light rounded-full font-bold uppercase tracking-wider hover:bg-brand-darker transition-colors duration-300 text-sm md:text-base" data-id="element-1096">
              <span data-id="element-1097">Demander un devis gratuit</span>
              <ArrowRight size={16} className="md:w-[18px] md:h-[18px]" data-id="element-1098" />
            </Link>
          </ScrollReveal>
        </div>
      </section>

      {/* Reviews Section */}
      <section className="py-16 md:py-24 lg:py-32 border-t border-brand-border/30 px-6 md:px-12" data-id="element-1099">
        <div className="max-w-[1400px] mx-auto" data-id="element-1100">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8" data-id="element-1101">
            {reviews.map((review, index) => <ScrollReveal key={index} delay={index * 0.1} data-id="element-1102">
                <div className="bg-brand-darker border border-brand-border/30 rounded-2xl p-6 md:p-8 h-full flex flex-col justify-between" data-id="element-1103">
                  <p className="text-brand-gray italic text-base md:text-lg leading-relaxed mb-6 md:mb-8" data-id="element-1104">
                    "{review.quote}"
                  </p>
                  <p className="text-brand-light text-sm md:text-base font-medium" data-id="element-1105">
                    — {review.author}
                  </p>
                </div>
              </ScrollReveal>)}
          </div>
        </div>
      </section>
      <NextPageLink data-id="element-1106" />
    </main>;
};